export * from './regex';

export const ACTION_TYPE_PREFIX = '@@ortk';
